<script>
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	function clickGraph(event) {
			console.log(this.innerText);
			dispatch("message", {
					text: this.innerText 
				})
		}

</script>

<div class="p-3 inline-type">
	<input type="radio"  id="bars" name="types">
	<label class="out-left" for="bars" on:click={clickGraph}>bars</label>
	<input type="radio" id="circle" name="types">
	<label class="in" for="circle" on:click={clickGraph}>circles</label>
	<input type="radio" checked id="sphere" name="types">
	<label class="in" for="sphere" on:click={clickGraph}>spheres</label>
	<input type="radio" id="turb" name="types">
	<label class="in" for="turb" on:click={clickGraph}>turb</label>
	<input type="radio" id="waves" name="types">
	<label class="out-right" for="waves" on:click={clickGraph}>waves</label>
</div>

<style>

label {
	border-radius: 0px;
	padding: 8px;
	margin: 0;
	font-weight: 500;
}

.out-left {
	border-left: 2px solid #000;
	border-radius: 5px 0px 0px 5px;
}

.in, .out-left, .out-right {
	border-top: 2px solid #000;
	border-bottom: 2px solid #000;
}

.out-right {
	border-right: 2px solid #000;
	border-radius: 0px 5px 5px 0px;
}

label:nth-of-type(even) {
	border-right: 2px solid #000;
	border-left: 2px solid #000;
}

input {
	display: none;
}

.inline-type {
	display: inline-flex;
	justify-content: center;
	width: 100%;
}

input[type="radio"]:checked+label {
	color: #fff;
	background-color: #000;
}

</style>
